import { App } from './core/App';
import './styles/main.css';
import { SplashScreen } from './objects/SplashScreen';

// Initialize the application
const splash = new SplashScreen();
// Start splash as early as possible (app can init behind it).
splash.start();

const app = new App();
app.init();
